<style scoped lang="scss">
    @import "../styles/mixins";

    .right {
        margin-left: 1%;
    }

    .p {
        padding-left: 28px;
    }

    .pic {
        li, img {
            @include w_h(60px);
        }
    }
</style>
<template>
    <div class="container">
        <div class="flex">
            <div class="flex0 width30">
                <gp-list></gp-list>
            </div>
            <div class="right flex0 width69 flex column bg_fff">
                <div class="title flex0 flex color_333 fs14 pl15 pr15 pt10 pb10 bb">
                    <span class="flex0">李俊基</span>
                    <span class="flex0 ml5">男</span>
                    <span class="flex0 ml5">23岁</span>
                    <span class="flex0 ml5">就诊卡号：100098</span>
                </div>
                <div>
                    <v-title title="病情描述：" size="15"></v-title>
                    <div class="p pr15 pb15 fs12 color_999">
                        医生医生，我有个问题想咨询你一下，小腹胀痛，不知道看哪个科室。医生医生，我有个问题想咨询你一下，小腹胀痛，不知道看哪个科室。医生医生，我有个问题想咨询你一下，小腹胀痛，不知道看哪个科室。医生医生，我有个问题想咨询你一下，小腹胀痛，不知道看哪个科室。医生医生，我有个问题想咨询你一下，小腹胀痛，不知道看哪个科室。
                    </div>
                    <ul class="pic flex pl15">
                        <li v-for="i in 6" class="flex0 mr10">
                            <img src="../assets/1.png" alt="">
                        </li>
                    </ul>
                    <div class="flex fs14 color_333 pl15 pr15 aic pt10 pb10">
                        <img src="../assets/头像.png" alt="">
                        <span class="flex1 ml5">杜海涛</span>
                        <span>2017/9/7 14:24</span>
                    </div>
                </div>
                <message-box blank="55"></message-box>
                <send-msg-box>
                    <div class="flex1 flex jce aic" slot="btns">
                        <span class="fs14 color_main pointer" @click="$router.push('/main/registration')">预约挂号</span>
                    </div>
                </send-msg-box>
            </div>
        </div>
    </div>
</template>

<script>

  import GpList from "../components/gp/list";
  import VTitle from "../components/common/v-title";
  import MessageBox from "../components/common/message-box";
  import SendMsgBox from "../components/common/send-msg-box";

  export default {
    name: "Gp",
    data() {
      return {
        list: [],
        curr: {},
      }
    },
    computed: {},
    components: {SendMsgBox, MessageBox, VTitle, GpList},
    mixins: [],
    created() {
    },
    mounted() {
    },
    watch: {},
    methods: {},
  }
</script>

